export const planoCarro = [
  { item: 'COBERTURA A ROUBO / FURTO / COLISÃO E PERDA TOTAL', valor: 'INCLUSO', percentual: '100% Fipe' },
  { item: 'INCÊNDIO POR COLISÃO', valor: 'INCLUSO', percentual: '100% Fipe' },
  { item: 'FENÔMENOS DA NATUREZA', valor: 'INCLUSO', percentual: '100% Fipe' },
  { item: 'PROTEÇÃO P/3° DANOS MATERIAIS ', valor: 'Até R$ 50 MIL', percentual: '-' },
  { item: 'ASSISTÊNCIA 24 HORAS - PANE ELÉTRICA/MECÂNICA', valor: '400 KM Total', percentual: '-' },
  { item: 'ASSISTÊNCIA 24 HORAS - SINISTRO', valor: 'KM Ilimitado', percentual: '-' },
  { item: 'CARRO RESERVA', valor: 'INCLUSO', percentual: '15 DIAS' },
  { item: 'COBERTURA DE VIDROS, FARÓIS E RETROVISORES', valor: 'INCLUSO', percentual: '40% Participação' },
  { item: 'COBERTURA PEQUENAS AVARIAS', valor: 'Até R$ 500,00', percentual: '40% Participação' },
  { item: 'CHAVEIRO ( SOMENTE ABERTURA DE PORTAS) ', valor: 'Até R$ 100,00', percentual: '2X ANO' },
  { item: 'HOTEL EM CASO DE EVENTOS', valor: 'Até R$ 150,00', percentual: '2X ANO' },
  { item: 'RETORNO A DOMICÍLIO APÓS EVENTO', valor: 'Até R$ 300,00', percentual: '2X ANO' },
  { item: 'VEÍCULOS ACIMA DE 100MIL - OBRIGATÓRIO RASTREAMENTO', valor: 'R$ 59,90', percentual: '-' },
];

export const planoMotocicleta = [
  { item: 'COBERTURA A ROUBO / FURTO / COLISÃO E PERDA TOTAL', valor: 'INCLUSO', percentual: '100% Fipe' },
  { item: 'INCÊNDIO POR COLISÃO', valor: 'INCLUSO', percentual: '100% Fipe' },
  { item: 'FENÔMENOS DA NATUREZA', valor: 'INCLUSO', percentual: '100% Fipe' },
  { item: 'ASSISTÊNCIA 24 HORAS - PANE ELÉTRICA/MECÂNICA', valor: '400 KM Total', percentual: '-' },
  { item: 'ASSISTÊNCIA 24 HORAS - SINISTRO', valor: 'KM Ilimitado', percentual: '-' },
  { item: 'REVISÃO GRATUITA (SOMENTE LUBRIFICAÇÃO)', valor: '3 X ANO', percentual: '-' },
];
